<div class="login-wrapper">
  <div class="image-container">
    <img class="image" [class.image-wordmark]="brand.isMosten" [src]="brand.logoLogin" alt="Logo" />
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
  <div class="login-container">
    <form (ngSubmit)="onSubmit()" class="form" [formGroup]="loginForm">
      <div class="brand">
        <p>ParkingHub by</p>
        <img
          width="100"
          height="40"
          src="assets/mosten-logo.svg"
          alt="Mosten Logo"
        />
      </div>
      <h1>Bem-vindo!</h1>
      <div class="form-group">
        <app-input
          type="text"
          label="E-mail ou Username"
          name="TX_MAIL_FUNC"
          formControlName="TX_MAIL_FUNC"
          placeholder="exemplo@email.com.br"
        ></app-input>
        <app-input
          type="password"
          label="Senha"
          name="TX_SENH_FUNC"
          formControlName="TX_SENH_FUNC"
          placeholder="Digite aqui"
        ></app-input>
      </div>
      <div class="checkbox-container">
        <label class="forgot-password" (click)="goTo('/recuperar-senha')"
          >Esqueceu a senha?</label
        >
      </div>
      <app-botao
        class="button"
        type="primario"
        width="100%"
        text="Entrar"
        (click)="onSubmit()"
      />
    </form>
  </div>
</div>
